import { Card as UnstyledCard, styled } from "@mui/material";

export const Card = styled(UnstyledCard)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.grey[300]}`,
  padding: theme.spacing(6),

  ":hover": {
    backgroundColor: theme.palette.grey[200],
    cursor: "pointer",
  },
}));

export const Label = styled("span")(({ theme }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: theme.spacing(2),
  justifyContent: "center",
  alignItems: "center",
}));
